export default {
    names: {
        hour: "час",
        minute: "минута",
        day: "день",
    },
    objects: {
        offline_update: "Отключить проверку обновлений",
        time: "Время",
        type_time: "Формат времени",
        button_save: "Сохранить",
        period: "Период проверки обновлений",
        address: "Адрес сервера для обновлений",
    },
    notification: {
        incorrect_data: "Значение не должно быть 0",
        load_error: "Ошибка загрузки",
        download_ok: "Изменения сохранены",
        download_error: "Ошибка при сохранении",
    },
}